module.exports = __webpack_public_path__ + "img/cate_jt.5773bd18.svg";